import React, { useState } from 'react';
import './Research.css';

// Importa os dados (ficam estáticos)
import { artigosSelecionados, livrosPublicados, chapters, allPublications } from './ResearchData';

// Importa os ícones
import researchIcon from '../../images/icons/research.png';
import selectedIcon from '../../images/icons/selected.png';
import bookIcon from '../../images/icons/book.png';
import pubsIcon from '../../images/icons/pubs.png';

// Importa o contexto de linguagem
import { useLanguage } from '../../context/LanguageContext';

function Research() {
  // Usa a função t do contexto para traduzir os títulos, subtítulos e o botão de DOI
  const { t } = useLanguage();
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filtra "allPublications" conforme o searchTerm (busca em title + reference)
  const filteredAllPubs = allPublications.map((yearItem) => {
    const filteredList = yearItem.list.filter((pub) => {
      const texto = (pub.title + pub.reference).toLowerCase();
      return texto.includes(searchTerm.toLowerCase());
    });
    return {
      ...yearItem,
      list: filteredList,
    };
  });

  return (
    <main className="research-container">
      <h1 className="research-title">
        {t('researchTitle')}
        <img src={researchIcon} alt="Research" className="title-icon" />
      </h1>

      {/* --- Artigos Selecionados --- */}
      <section className="research-section">
        <h2 className="section-title">
          {t('selectedTitle')}
          <img src={selectedIcon} alt="Selected" className="section-icon" />
        </h2>
        <div className="research-list">
          {artigosSelecionados.map((item, index) => (
            <div className="research-card" key={index}>
              <h3 className="pub-title">{item.title}</h3>
              <p className="pub-authors">{item.authors}</p>
              <p className="pub-reference">{item.reference}</p>
              {item.doi && (
                <a
                  href={item.doi}
                  target="_blank"
                  rel="noreferrer"
                  className="doi-button"
                >
                  {t('doiButtonText')}
                </a>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* --- Livros Publicados --- */}
      <section className="research-section">
        <h2 className="section-title">
          {t('booksTitle')}
          <img src={bookIcon} alt="Book" className="section-icon" />
        </h2>
        <div className="research-list">
          {livrosPublicados.map((item, index) => (
            <div className="research-card" key={index}>
              <h3 className="pub-title">{item.title}</h3>
              <p className="pub-authors">{item.authors}</p>
              <p className="pub-reference">{item.reference}</p>
              {item.doi && (
                <a
                  href={item.doi}
                  target="_blank"
                  rel="noreferrer"
                  className="doi-button"
                >
                  {t('doiButtonText')}
                </a>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* --- ALL PUBLICATIONS --- */}
      <section className="research-section">
        <h2 className="section-title">
          {t('allPublicationsTitle')}
          <img src={pubsIcon} alt="Publications" className="section-icon" />
        </h2>

        {/* Caixa de busca */}
        <div className="search-box-container">
          <input
            type="text"
            placeholder= {t('placeholdersearchBox')}
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Listagem por ano */}
        <div className="all-pubs">
          {filteredAllPubs.map((yearItem) => {
            if (yearItem.list.length === 0) return null;
            return (
              <div key={yearItem.year} className="year-block">
                <h3 className="pub-year">{yearItem.year}</h3>
                <div className="pub-entries">
                  {yearItem.list.map((pub, idx) => (
                    <div key={idx} className="pub-entry">
                      <p className="pub-title-year">{pub.title}</p>
                      <p className="pub-authors-year">{pub.authors}</p>
                      <p className="pub-reference-year">{pub.reference}</p>
                      {pub.doi && (
                        <a
                          href={pub.doi}
                          target="_blank"
                          rel="noreferrer"
                          className="doi-button"
                        >
                          {t('doiButtonText')}
                        </a>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
}

export default Research;
